import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useFetchWebsocket = () => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.FETCH_WEBSOCKET }), []);
};

const useProcessMessage = () => {
  const handler = useDispatch();
  return useCallback(({ data }) => handler(JSON.parse(data).message), []);
};

export default {
  useFetchWebsocket,
  useProcessMessage,
};
